import Box from "@mui/material/Box";
import PreviewMarker from "../../partials/PreviewMarker";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import { useQuadrantViewedStatus } from "../../../../../../features/quadrants/api/getQuadrantViewedStatus";
import { useRegisterView } from "../../../../../../features/quadrants/api/registerView";
import { useWaterMark } from "../../../../../../features/quadrants/hooks/useWaterMark";

function TextContent({
  contentId,
  mandatory,
  sx,
  htmlText,
  text,
  children,
  auth,
  enrollment,
  chapters,
  isConfidential = false,
}) {
  const { currentChapter } = useParams();
  const waterMarkCn = useWaterMark();

  const quarantViewedStatusQuery = useQuadrantViewedStatus({
    chapterId: currentChapter,
    enrollmentId: enrollment?.MATRICULAID,
    quadrantId: contentId,
  });

  const registerViewMutation = useRegisterView();

  const handleClickView = () => {
    if (!quarantViewedStatusQuery.data?.viewed) {
      registerViewMutation.mutate({
        enrollmentId: enrollment.MATRICULAID,
        quadrantId: contentId,
      });
    }
  };
  const modules = {
    toolbar: false,
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        padding: "0 0 0 0",
      }}
      className={isConfidential && waterMarkCn.WatermarkScrollthrough}
    >
      {mandatory === "S" && (
        <span className="top-0 left-0" onClick={handleClickView}>
          <PreviewMarker
            viewed={quarantViewedStatusQuery.data?.viewed}
            TooltipValue={"Leia o texto e clique aqui"}
          />
        </span>
      )}
      {htmlText ? (
        <Box sx={{ height: "100%", overflow: "auto" }}>
          <div
            style={{
              marginTop: "0px",
              height: "fit-content",
              width: "inherit",

              ...sx,
            }}
            className={isConfidential && "select-none cursor-default"}
          >
            <ReactQuill modules={modules} value={htmlText} readOnly />
          </div>
        </Box>
      ) : (
        <Box
          sx={sx}
          height="inherit"
          width="inherit"
          className={isConfidential && "select-none"}
        >
          {text || children}
        </Box>
      )}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  enrollment: state.course?.enrollment,
  chapters: state.course?.chapters,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TextContent);
